export const learnEventStatisticsByNpu = (params) => {
  const {
    eventOpeartionObjectDetail,
    eventOpeartionObjectCode,
    eventDetail,
    eventModel,
    eventName,
  } = params
  learnEventStatistics({
    detail: eventDetail,
    modular: eventModel,
    modularObject: eventName,
    resource_id: eventOpeartionObjectCode,
    resource_name: eventOpeartionObjectDetail,
  })
}

export const learnEventStatistics = (params) => {
  const {
    modular,
    modularObject,
    resource_id,
    resource_name,
    detail,
  } = params
  const data = {
    createCode: window.loginUserInfo.user_id,
    description: '',
    detail,
    ip: '',
    logType: '',
    modular,
    modularObject,
    operationResults: '',
    org_code: window.loginUserInfo.extend.orgcodepath,
    requestParam: '',
    requestType: '',
    requestUrl: '',
    resource_id,
    resource_name,
    timeMillis: new Date().getTime(),
    useRole: (window.loginUserInfo.roles || []).join(','),
    username: window.loginUserInfo.nick_name
  }
  API.reqUserLog(data)
}

